import React from "react";
import { Link } from "react-router-dom";
import { Container } from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";

const Resources = () => {
  document.title = "Resources | Buyers Club";
  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Resources" pageTitle="Resources" />
        <div className="faq-section">
          <h3>
            Below is a list of resources that you can explore. Each link
            provides access to specific tools or information:{" "}
          </h3>
          <div className="faq-item">
            <h5>What is the refresh schedule?</h5>
            <p>
              There is no longer a weekly refresh; products are uploaded and
              updated weekly.
            </p>
          </div>
          <div className="faq-item">
            <h5>Where can I find authorization letters for suppliers?</h5>
            <p>
              While we work on adding this feature to the system, please contact the support desk at <a href="mailto:support@mybuyersclub.net">support@mybuyersclub.net</a> if you need assistance.
            </p>
          </div>
          {/* <div className="faq-item">
          <div className="faq-item">
            <h5>What are the authorized brands?</h5>
            <p>
              You can find a list of authorized brands in the resources section.
            </p>
          </div>
          </div> 
          <div className="faq-item">
            <h5>Where can I access office hour replays?</h5>
            <p>
              Links to office hour replays are available in the resources
              section.
>>>>>>> Stashed changes
            </p>
          </div>
          */}
          <div className="faq-item">
            <h5>
              How can I access Sellercloud?
            </h5>
            <p>
              Visit{" "}
              <a
                href="https://buyersclub.sellercloud.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Sellercloud
              </a>
              .
            </p>
          </div>
          <div className="faq-item">
            <h5>
              How can I access the Sellercloud learning management system?
            </h5>
            <p>
              Visit the{" "}
              <a
                href="https://help.sellercloud.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Sellercloud learning management system
              </a>
              .
            </p>
          </div>
          <div className="faq-item">
            <h5>Where can I find training and updates?</h5>
            <p>
              Visit the{" "}
              <a
                href="https://members.omcaccess.com/login"
                target="_blank"
                rel="noopener noreferrer"
              >
                Training and Updates page
              </a>
              .
            </p>
          </div>
          <div className="faq-item">
            <h5>How can I contact the support desk?</h5>
            <p>
              You can reach out to the support desk at{" "}
              <a
                href="https://support.blueprintcentral.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                support.blueprintcentral.com
              </a>
              .
            </p>
          </div>
          <div className="faq-item">
            <h5>How to Get Support?</h5>
            <p>
              <Link to="/resources/how-to-get-support">
                View the step-by-step support guide
              </Link>
              .
            </p>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Resources;
